export const darkTheme = {
  background: {
    primary: '#181820',
    secondary: '#21212b',
    tertiary: '#21212b',
    light: '#50506c',
    active: '#fda0a7',
    hover: '#5b5b77',
  },
  color: {
    primary: '#fff',
    secondary: '#dedee0',
    greeting: '#D57969',
    tasks: '#ab6a65',
    completed: '#13989b',
  },
  font: {
    w_normal: 400,
    w_light: 300,
    w_bold: 500,
  },
}
const lightTheme = {
  background: {
    primary: '#cedbff',
    secondary: '#97a4c6',
    tertiary: '#97a4c6',
    light: '#50506c',
    active: '#3570d3',
    hover: '#5b5b77',
  },
  color: {
    primary: '#000',
    secondary: '#1f2125',
    greeting: '#D57969',
    tasks: '#ab6a65',
    completed: '#13989b',
  },
  font: {
    w_normal: 400,
    w_light: 300,
    w_bold: 500,
  },
}
const theme = {
  light: lightTheme,
  dark: darkTheme,
}
export default theme
